export const requiredIcon = (condition: boolean) => {
  return condition ? <span className='input-require'>*</span> : null
}
